'use client';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useBrowserLayoutEffect } from '@/hooks/useBrowserLayoutEffect';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import styles from './ToolbarPortal.module.scss';

interface IToolbarPortal {
  animate?: boolean;
  children: React.ReactNode;
  breakpoints?: string[];
  clientOnly?: boolean;
}

export const ToolbarPortal = ({ animate = false, breakpoints = ['xs'], children, clientOnly = true }: IToolbarPortal) => {
  const breakpoint = useBreakpoint();
  const [isOnBreakpoint, setIsOnBreakpoint] = useState(false);

  useBrowserLayoutEffect(() => {
    const matchesCurrentBreakpoint = breakpoints.includes(breakpoint);
    setIsOnBreakpoint(matchesCurrentBreakpoint);
  }, [breakpoint]);

  useBrowserLayoutEffect(() => {
    document.body.classList.add(styles.toolbarOpen);
    return () => document.body.classList.remove(styles.toolbarOpen);
  }, []);

  if (isOnBreakpoint) {
    return createPortal(
      <div className={`${animate ? 'animated faster fadeInUp' : ''} ${styles.toolbarPortal}`}>
        <Container className="h-100">
          <Row className="h-100">
            <Col xs="12" className="px-0 h-100">
              <div id="toolbarPortal" className={styles.toolbarContainer}>
                {children}
              </div>
            </Col>
          </Row>
        </Container>
      </div>,
      document.body
    );
  }

  return <>{clientOnly ? null : children}</>;
};
